module.exports = __webpack_public_path__ + "static/media/store-Deezer.9d1a6497.svg";